import { z } from "zod"

export const SubmitPriceChangeSchema = z.object({
  reasonForUpdate: z
    .string()
    .nullable()
    .refine((value): boolean => value !== null, { message: "Reason For Update is required" }),
})

export type SubmitPriceChangeSchemaFormValues = z.infer<typeof SubmitPriceChangeSchema>
